<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :title="page"
        :breadcrumbs="breadcrumbs"
        icon="mdi-package-variant"
    ></vuse-section-definition>
    <v-row class="mx-1">
      <v-col class="mx-3" cols="3.5" sm="3.5">
        <v-text-field
            background-color="#EDF2F7"
            filled
            v-model="product.name"
            item-text="text"
            item-value="value"
            label="Tên sản phẩm"
            @input="debounceInputName"
        ></v-text-field>
      </v-col>
      <v-col class="mx-3" cols="3.5" sm="3.5">
        <v-select
            background-color="#EDF2F7"
            filled
            :items="brandSelect"
            v-model="product.brand_id"
            item-text="name"
            item-value="id"
            label="Nhãn hàng"
            @change="getItem"
        ></v-select>
      </v-col>
      <v-col class="mx-3" cols="3.5" sm="3.5">
        <v-select
            background-color="#EDF2F7"
            filled
            v-model="product.stock_status"
            :items="warehouse"
            item-text="text"
            item-value="value"
            label="Trạng thái kho"
            @change="getItem"
        ></v-select>
      </v-col>
      <!--      <v-col cols="1.5">-->
      <!--        <v-btn color="primary" @click="getItem"> Search </v-btn>-->
      <!--      </v-col>-->
      <v-col align="right" v-if="hasPermissions('Create product')">
        <v-btn color="primary" align="right" @click="addNew">
          Thêm sản phẩm
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="mx-1">
      <v-col class="mx-3" cols="3.5" sm="3.5">
        <v-text-field
            background-color="#EDF2F7"
            filled
            v-model="product.serial_number"
            item-text="text"
            item-value="value"
            label="Mã sản phẩm"
            @input="debounceInputCode"
        ></v-text-field>
      </v-col>
      <v-col class="mx-3" cols="3.5" sm="3.5">
        <v-text-field
            background-color="#EDF2F7"
            filled
            v-model="product.slug"
            label="Slug"
            @input="debounceInputSlug"
        ></v-text-field>
      </v-col>
      <v-col class="mx-3" cols="3.5" sm="3.5">
        <v-text-field
            background-color="#EDF2F7"
            filled
            type="number"
            v-model="product.price_from"
            label="Giá từ"
            @input="debounceInputFrom"
        ></v-text-field>
      </v-col>
      <v-col class="mx-3" cols="3.5" sm="3.5">
        <v-text-field
            type="number"
            background-color="#EDF2F7"
            filled
            v-model="product.price_to"
            label="Giá đến"
            @input="debounceInputTo"
        ></v-text-field>
      </v-col>

    </v-row>

    <v-container fluid class="content_product1">
      <v-row justify="center" align="center">
        <v-col cols="12">
          <v-data-table
              :headers="headers"
              :items="productSearches"
              :page.sync="page_number"
              :items-per-page="itemsPerPage"
              class="elevation-1"
              @page-count="pageCount = $event"
          >
            <template v-slot:item.name="{ item }">
              <span>{{item.name}} <a :href="`${url}accessory/${item.category_slug}/${item.slug}`" target="_blank" >Xem trên web</a></span>
            </template>
            <template v-slot:item.thumb_url_path="{ item }">
              <img :id="item.id" :src="item.thumb_url_path" width="50px" height="50px" />
            </template>
            <template v-slot:item.quantity="{ item }">
              <span v-if="item.quantity >=1" >Còn hàng</span>
              <span v-else >Hết hàng</span>
            </template>
            <template v-slot:item.brand_photo_url="{ item }" >
              <img :src="item.brand_photo_url ? item.brand_photo_url : require('@/assets/images/bi_image.png')" class="img-brand">
            </template>

            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItem(item)" v-if="hasPermissions('Update product')">
                mdi-pencil
              </v-icon>
              <!-- <v-icon small class="mr-2" @click="reviewItem(item)">
                mdi-eye
              </v-icon> -->
              <v-icon small @click="deleteItem(item)" v-if="hasPermissions('Delete product')"> mdi-delete </v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { DELETE_PRODUCT, GET_LIST_PRODUCT_SEARCH } from "@/store/modules/production";
import { GET_LIST_BRAND } from "@/store/modules/brand";
import { mapGetters } from "vuex";
import {debounce} from "debounce";
export default {
  data() {
    return {
      current_page: 1,
      page_number: 1,
      url:'',
      pageCount: 0,
      itemsPerPage: 10,
      search:'',
      page: "Quản lý phụ kiện",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Quản lý phụ kiện",
          disabled: true,
        },
        {
          text: "Danh sách phụ kiện",
          disabled: true,
        },
      ],
      warehouse: [
        {
          value: -1,
          text: "Chọn tất cả",
        },
        {
          value: 1,
          text: "Còn hàng",
        },
        {
          value: 2,
          text: "Hết hàng",
        },
      ],
      product :[
        {name : ""},
        {brand_id : null},
        {price_from : null},
        {price_to : null},
        {serial_number : null},
        {stock_status : null},
        {slug : null},
        {page_current : null},
      ],
      headers: [
        { text: "ID", value: "id", align: "start" },
        {
          text: "Hình ảnh",
          sortable: false,
          value: "thumb_url_path",
        },
        { text: "Tên", value: "name" },
        { text: "Nhãn hàng", value: "brand_photo_url" },
        { text: "Trạng thái kho", value: "quantity" },
        { text: "Giá tiền (vnđ)", value: "price" },
        { text: "Giá discount (vnđ)", value: "discount" },
        { text: "Actions", value: "actions" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      productions: "productions",
      brands: "brands",
      productSearches : "productionSearches",
    }),
    brandSelect() {
      let arr = [...this.brands];
      arr.unshift({ id: "-1", name: "Chọn tất cả" });
      return arr;
    },

  },

  async created() {
    this.page_number = parseInt(this.$route.query.page_current) || 1
    this.product.name = this.$route.query.name || ''
    this.product.brand_id = parseInt(this.$route.query.brand_id) || ''
    this.product.stock_status =  parseInt(this.$route.query.stock_status) || 0
    this.product.serial_number =this.$route.query.serial_number || ''
    this.product.slug = this.$route.query.slug || ''
    this.product.price_from = this.$route.query.price_from || ''
    this.product.price_to = this.$route.query.price_to || ''
    this.params();
    this.url = process.env.VUE_APP_URL;
    await this.$store.dispatch(GET_LIST_BRAND);
  },

  methods: {
    replaceProduction() {
      this.$router.replace({
        query: {
          name: this.product.name,
          brand_id: this.product.brand_id != "-1" ? this.product.brand_id : null,
          stock_status: this.product.stock_status,
          serial_number: this.product.serial_number,
          price_from: this.product.price_from,
          price_to: this.product.price_to,
          slug: this.product.slug,
          page_current: parseInt(this.page_number),
        }
      })
    },
    params(){
      let params = {
        stock_status : this.product.stock_status,
        name : this.product.name,
        brand_id : this.product.brand_id ,
        serial_number: this.product.serial_number,
        price_from : this.product.price_from,
        price_to : this.product.price_to,
        slug: this.product.slug,
        product_type:1
      }
      this.$store.dispatch(GET_LIST_PRODUCT_SEARCH, params);
    },
    debounceInputName: debounce(function (e) {
      this.product.name = e;
      this.replaceProduction();
      this.params();
    }, 200),

    debounceInputCode: debounce(function (e) {
      this.product.serial_number = e;
      this.replaceProduction();
      this.params();
    }, 200),

    debounceInputSlug: debounce(function (e) {
      this.product.slug = e;
      this.replaceProduction();
      this.params();
    }, 200),

    debounceInputFrom: debounce(function (e) {
      this.product.price_from = e;
      this.replaceProduction();
      this.params();
    }, 200),

    debounceInputTo: debounce(function (e) {
      this.product.price_to = e;
      this.replaceProduction();
      this.params();
    }, 200),

    getItem() {
      this.replaceProduction();
      this.params();
    },
    editItem(item) {
      this.replaceProduction();
      this.$router.push({
        path: "/manage_productions/accessory/edit_accessory/" + item.id,
      });
    },
    reviewItem() {},
    deleteItem(item) {
      confirm("Bạn có chắc muốn xóa?") &&
      this.$store.dispatch(`${DELETE_PRODUCT}`, item.id).then((data) => {
        if (data && data.status === 1) {
          this.params();
        }
      });
    },
    addNew() {
      this.$router.push("/manage_productions/accessory/addnew_accessory");
    },
  },
};
</script>
<style lang="scss">
.content_product1 {
  background: #ffffff !important;
}
.img-brand {
  max-width: 100px;
  max-height: 100px;
  margin: auto;
  display: block;
}
</style>